import { useEffect } from "react";
import {
  getCityList,
  getMetaData
} from "../containers/JobPosting/jobPostingActions";
import { useDispatch, useSelector } from "react-redux";

interface categoryCityLabelsProps {
  cityId?: string;
  categoryId?: number;
}

interface categoryCityLabels {
  cityLabel?: string;
  categoryLabel?: string;
}

const useMetaLabels = (props: categoryCityLabelsProps): categoryCityLabels => {
  const { cityId, categoryId } = props;
  const dispatch = useDispatch();
  const categoriesObj = useSelector(
    (state: any) => state.jobPostingReducer.metaData.payload.categories
  );
  const citiesObj = useSelector((state: any) => state.jobPostingReducer.city);
  const { payload = [] } = citiesObj;
  const { options = [] } = categoriesObj;
  const { label: cityLabel = "" } =
    payload.find((city: any) => city._id === cityId) || {};
  const { title: categoryLabel = "" } =
    options.find((category: any) => category.id === categoryId) || {};

  useEffect(() => {
    if (cityId) {
      dispatch(getCityList());
    }
    if (categoryId) {
      dispatch(getMetaData());
    }
  }, [cityId, categoryId]);

  return { cityLabel, categoryLabel };
};

export default useMetaLabels;
